import {
    MutationCache,
    QueryCache,
    QueryClient,
    QueryClientProvider as TanstackQueryClientProvider,
} from '@tanstack/react-query';
import { docsapiContract } from '@this/shared/dist/apis/docsapi.js';
import { config } from '@this/shared/dist/tools/config.js';
import { logger } from '@this/shared/dist/tools/logger.js';
import type { FetchOptions } from '@ts-rest/core';
import { tsRestFetchApi } from '@ts-rest/core';
import { initTsrReactQuery } from '@ts-rest/react-query/v5';
import { useMemo } from 'react';

export function useTsRest(fetchOptions?: FetchOptions) {
    return useMemo(
        () =>
            initTsrReactQuery(docsapiContract, {
                baseUrl: config.service.docsApi.baseUrl,
                api: async (args) => {
                    return tsRestFetchApi({
                        ...args,
                        fetchOptions,
                    });
                },
                jsonQuery: true,
            }),
        [fetchOptions]
    );
}

const queryClient = new QueryClient({
    queryCache: new QueryCache({
        onError: (error) => {
            logger.error('Query error:', error);
        },
    }),
    mutationCache: new MutationCache({
        onError: (error) => {
            logger.error('Mutation error:', error);
        },
    }),
    defaultOptions: {
        queries: {
            staleTime: 5 * 60 * 1000,
        },
    },
});

export function QueryClientProvider({ children }: { children: React.ReactNode }) {
    const tsr = useTsRest();

    return (
        <TanstackQueryClientProvider client={queryClient}>
            <tsr.ReactQueryProvider>{children}</tsr.ReactQueryProvider>
        </TanstackQueryClientProvider>
    );
}
